import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { PickerComputer } from '../picker-computer/PickerComputer';
import { PickerFamilyFriends } from '../picker-family-friends/PickerFamilyFriends';
import { PickerGallery } from '../picker-gallery/PickerGallery';
import { PickerGooglePhotos } from '../picker-google-photo/PickerGooglePhoto';
import { PickerSmartphone } from '../picker-smartphone/PickerSmartphone';


const PickerMap = {
  [SELECTED_MENU_ITEMS.GooglePhoto]: {
    Picker: PickerGooglePhotos,
    pickerTitleKey: `upload:${SELECTED_MENU_ITEMS.GooglePhoto}`,
  },
  [SELECTED_MENU_ITEMS.FamilyFriends]: {
    Picker: PickerFamilyFriends,
    pickerTitleKey: `upload:${SELECTED_MENU_ITEMS.FamilyFriends}`,
  },
  [SELECTED_MENU_ITEMS.Smartphone]: {
    Picker: PickerSmartphone,
    pickerTitleKey: `upload:${SELECTED_MENU_ITEMS.Smartphone}`,
  },
  [SELECTED_MENU_ITEMS.Computer]: {
    Picker: PickerComputer,
    pickerTitleKey: `upload:title-choose`,
    pickerDescriptionKey: `upload:long-press-zoom`,
  },
  [SELECTED_MENU_ITEMS.Gallery]: {
    Picker: PickerGallery,
    pickerTitleKey: `upload:title-choose`,
    pickerDescriptionKey: `upload:long-press-zoom`,
  },
};

export const DesktopPickerMap = {
  [SELECTED_MENU_ITEMS.GooglePhoto]: PickerMap[SELECTED_MENU_ITEMS.GooglePhoto],
  [SELECTED_MENU_ITEMS.FamilyFriends]: PickerMap[SELECTED_MENU_ITEMS.FamilyFriends],
  [SELECTED_MENU_ITEMS.Smartphone]: PickerMap[SELECTED_MENU_ITEMS.Smartphone],
  [SELECTED_MENU_ITEMS.Computer]: PickerMap[SELECTED_MENU_ITEMS.Computer],
};

export const MobilePickerMap = {
  [SELECTED_MENU_ITEMS.GooglePhoto]: PickerMap[SELECTED_MENU_ITEMS.GooglePhoto],
  [SELECTED_MENU_ITEMS.FamilyFriends]: PickerMap[SELECTED_MENU_ITEMS.FamilyFriends],
  [SELECTED_MENU_ITEMS.Gallery]: PickerMap[SELECTED_MENU_ITEMS.Gallery],
};
